import { useState } from "react";
import {
    CMargin,
    DeleteIcon,
    DText,
    Flex,
    Row,
} from "../../../../styles/CommonStyles";
import { EditIcon } from "../../../../styles/main/setting";
import { getMainTheme } from "../../../../core/utils/theme";
import { RespIndex } from "../../../../styles/main/MainCommonStyles";
import ModalLayout from "../../../layout/main/ModalLayout";
import PackageModal from "./PackageModal";

const RPackageListTable = ({ packages = [] }) => {
    const [modal, setModal] = useState({ show: false, pkg: null, type: "edit" });

    const closeModal = () =>
        setModal({ show: false, pkg: null, type: "edit" });

    const openModal = (pkg, type = "edit") =>
        setModal({ show: true, pkg, type });

    return (
        <>
            {packages.map((pkg, idx) => {
                const featureList = Object.values(pkg.features || {});

                return (
                    <Row
                        cs="100%"
                        index={idx}
                        key={pkg.id}
                        style={{ position: "relative" }}
                    >
                        <CMargin margin="4px" />

                        {/* Name */}
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                Name :
                            </DText>
                            <DText fontSize="s" main>
                                {pkg.name}
                            </DText>
                        </Flex>

                        <CMargin margin="6px" />

                        {/* Description */}
                        <Flex justify="space-between" wrap>
                            <DText fontSize="s" main>
                                Description :
                            </DText>
                            <DText
                                fontSize="s"
                                main
                                style={{ textAlign: "right" }}
                            >
                                {pkg.description}
                            </DText>
                        </Flex>

                        <CMargin margin="6px" />

                        {/* Price */}
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                Price :
                            </DText>
                            <DText fontSize="s" main>
                                {pkg.price === 0
                                    ? "Free"
                                    : `$${pkg.price}`}
                            </DText>
                        </Flex>

                        <CMargin margin="6px" />

                        {/* Duration */}
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                Duration :
                            </DText>
                            <DText fontSize="s" main>
                                {pkg.duration} ماه
                            </DText>
                        </Flex>

                        <CMargin margin="6px" />

                        {/* Limits */}
                        <Flex direction="column">
                            <DText fontSize="s" main>
                                Limits :
                            </DText>

                            <DText fontSize="s">
                                Assistant: {pkg.assistant_limit ?? "∞"}
                            </DText>
                            <DText fontSize="s">
                                Trigger: {pkg.trigger_limit ?? "∞"}
                            </DText>
                            <DText fontSize="s">
                                FastScan: {pkg.fastscan_limit ?? "∞"}
                            </DText>
                        </Flex>

                        <CMargin margin="6px" />

                        {/* Subscriptions */}
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                Subscriptions :
                            </DText>
                            <DText fontSize="s" main>
                                {pkg.subscriptions}
                            </DText>
                        </Flex>

                        <CMargin margin="6px" />

                        {/* Features */}
                        <Flex direction="column">
                            <DText fontSize="s" main>
                                Features:
                            </DText>

                            <Flex fw wrap>
                                {featureList.map((feature, i) => (
                                    <Flex
                                        key={i}
                                        style={{
                                            border: "1px solid #444",
                                            borderRadius: "6px",
                                            padding: "2px 6px",
                                            margin: "2px",
                                            fontSize: "12px",
                                        }}
                                    >
                                        {feature}
                                    </Flex>
                                ))}
                            </Flex>
                        </Flex>

                        <CMargin margin="6px" />

                        {/* Actions */}
                        <Flex justify="flex-end" gap="10px">
                            <EditIcon
                                size={20}
                                color={getMainTheme().active}
                                style={{ cursor: "pointer" }}
                                onClick={() => openModal(pkg, "edit")}
                            />
                            <DeleteIcon
                                size={22}
                                color="#d33"
                                onClick={() => openModal(pkg, "delete")}
                            />
                        </Flex>

                        <RespIndex>{idx + 1}</RespIndex>
                    </Row>
                );
            })}

            <ModalLayout
                width={modal.type === "delete" ? "420px" : "620px"}
                open={modal.show}
                onClose={closeModal}
            >
                <PackageModal
                    onSuccess={closeModal}
                    _defaultPackage={modal.pkg}
                    existingPackages={packages}
                    type={modal.type}
                    closeModal={closeModal}
                />
            </ModalLayout>
        </>
    );
};

export default RPackageListTable;